import React, { Component } from 'react';
import Footer from './Footer'
import FadeIn from 'react-fade-in';
import DocumentTitle from 'react-document-title';
import Nav from './Nav';

class TermsAndPrivacy extends Component {

    constructor() {
        super();
        this.state = {
            navData: {
                links: [
                    {
                        name: 'Home',
                        href: '/synthcity'
                    },
                    {
                        name: 'synthLibrary',
                        href: '/the-library'
                    },
                ],
                callToAction:
                {
                    name: 'Join Alpha!',
                    href: 'https://www.synthcity.io'
                }
            }
        }
    }

    render() {
        return (
            <DocumentTitle title="Terms of Use and Privacy Policy | synthCity">
                <FadeIn>
                    <div id="synth-city-tos">
                        <Nav navData={this.state.navData} />
                        <div>
                            <section id="synth-search">
                                <header id="intro-hero" className="fullscreen dark-overlay" style={{ background: 'url(assets/img/intro-bg.jpg) no-repeat', backgroundSize: 'cover' }}>
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-12 hero-content text-white">
                                                <h1 className="hero-title">Terms of Use and Privacy Policy <br /> </h1>
                                                <p className="hero-tagline">
                                                    Privacy Policy
                                                    The synthCity SERVICE is provided by <a href='https://www.sojisoft.com' target='_blank'>Sojisoft Limited</a> and is intended for use as is. synthCity and all its respective assets are managed and owned by Sojisoft.

                                                    This page is used to inform website visitors regarding the policies with the collection, use, and disclosure of Personal Information of anyone using the Service.

                                                    If you choose to use the Service, then you agree to the collection and use of information in relation to this policy. The Personal Information that we collect is used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy.

                                                    The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at Sojisoft unless otherwise defined in this Privacy Policy.

                                                    <h3>Information Collection and Use</h3>

                                                    For a better experience, while using our Service, we may require you to provide us with certain personally identifiable information, including but not limited to First Name, Last Name and Email. The information that we request is will be retained by us and used as described in this privacy policy.

                                                    The app does use third party services that may collect information used to identify you.

                                                    None of your information is shared, distributed, sold, or stored outside of synthCity's servers.

                                                    <h3>Log Data</h3>

                                                    We want to inform you that whenever you use our Service, in a case of an error in the app we collect data and information (through third party products) called Log Data. This Log Data may include information such as your device Internet Protocol (“IP”) address, device name, operating system version, the configuration of the app when utilizing our Service, the time and date of your use of the Service, and other statistics.

                                                    <h3>Cookies</h3>

                                                    Cookies are files with small amount of data that is commonly used an anonymous unique identifier. These are sent to your browser from the website that you visit and are stored on your device internal memory.

                                                    This Service does not use these “cookies” explicitly. However, the app may use third party code and libraries that use “cookies” to collection information and to improve their services. You have the option to either accept or refuse these cookies and know when a cookie is being sent to your device. If you choose to refuse our cookies, you may not be able to use some portions of this Service.

                                                    <h3>Security</h3>

                                                    We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.

                                                    <h3>Links to Other Sites</h3>

                                                    This Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.

                                                    <h3>Children’s Privacy</h3>

                                                    These Services do not address anyone under the age of 13. We do not knowingly collect personally identifiable information from children under 13. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we may take necessary action.

                                                    <h3>During the Alpha</h3>
                                                    Early access alpha users are users who signed up to the platform before the 31st of March 2019 and remained subscribed to email updates throughout the duration of the Alpha. These users are entitled to free lifetime access to the social synthesizer sharing and requesting features of the synthCity platform, i.e, the ability to download patches freely shared by other users of the platform and the ability to request presets. This does not grant free license to any subsequent services offered by synthCity. The lifetime access may be revoked at anytime for reasons including but not limited to harassing other users or attempting to use the site maliciously.

                                                    <h3>Sharing on synthCity</h3>
                                                    By using the application you confirm that you have the right to distribute anything you share using the app. You also agree that you will assume full responsibility for any proceedings federal or legal, should you share a file which you were not licensed to share. By sharing you also grant us the right to store, modify and redistribute what you upload.

                                                    <h3>DMCA Notice</h3>
                                                    If you suspect a user is re-distributing files you own without an appropriate license please get in touch at <a href="mailto:info@synthcity.io">info@mazinomedia.com</a>.

                                                    <h3>Changes to This Privacy Policy</h3>

                                                    We may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately after they are posted on this page.

                                                    <h3>Contact Us</h3>

                                                    If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us at info@synthcity.io.
                                                </p>
                                            </div> {/* END col-12*/}
                                            <div className="col-12 mt-5">
                                            </div> {/* END col-12*/}
                                        </div> {/* END row*/}
                                    </div> {/* END container*/}
                                </header> {/* END header*/}
                            </section>
                        </div>
                        <Footer />
                    </div>
                </FadeIn>
            </DocumentTitle>
        );
    }
}

export default TermsAndPrivacy;


// WEBPACK FOOTER //
// ./src/components/synthcity/TermsAndPrivacy.js